/* eslint-disable class-methods-use-this */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import _ from 'lodash';
import moment from 'moment';
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import Form from '../../../components/form/form';
import OneClickButton from '../../../components/form/button';
import addNotification from '../../../components/notification';
import { getPageLayout, updatePageLayout } from '../../../app/store/actions/pageLayout';

import Table from '../../../components/table/Table';

import StockMovementsHelpers from '../../../helpers/stockMovements';

import { getStockMovements } from '../../../app/store/actions/stocks';

import FormatHelpers from '../../../helpers/format';
import ROUTES from '../../../config/routes';

class StockMovementList extends React.Component {
  constructor(props) {
    super(props);

    this.page = 0;
    this.pageSize = 10;
    this.sorted = [];
    this.filtered = [];
    this.lastDateSignature = null;

    this.state = {
      startDate: moment().subtract(30, 'd'),
      endDate: moment(),
      pages: 0,
      totalDataLength: 0,
      showModalPageLayout: false,
      tableColumns: [],
      pageLayout: {
        showLoadNumber: true,
        showInvoiceNumber: true,
        showSocialName: true,
        showDepositName: true,
        showBaptismLabel: true,
        showName: true,
        showUnitMeasure: true,
        showAddressCode: true,
        showLotNumber: true,
        showExpirationDate: true,
        showManufacturingDate: true,
        showSerialGroup: true,
        showSerialLabel: true,
        showMovementUserName: true,
        showNote: true,
      },
      showLoadNumber: true,
      showInvoiceNumber: true,
      showSocialName: true,
      showDepositName: true,
      showBaptismLabel: true,
      showName: true,
      showUnitMeasure: true,
      showAddressCode: true,
      showLotNumber: true,
      showExpirationDate: true,
      showManufacturingDate: true,
      showSerialGroup: true,
      showSerialLabel: true,
      showMovementUserName: true,
      showNote: true,
    };

    this.defaultSorted = [
      { id: 'movementDate', desc: true },
      { id: 'id', desc: true },
    ];

    this.allTableColumns = [
      {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 80,
        Filter: this.filterColumn,
      },
      {
        Header: I18n.t('BEE200' /* Tipo */),
        accessor: 'type',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 110,
        Cell: (row) => (
          <div style={{ textAlign: 'center' }}>
            <span>{StockMovementsHelpers.movementType(row.value)}</span>
          </div>
        ),
        Filter: ({ onChange }) => (
          <select
            type="text"
            style={{ width: '100%' }}
            onChange={(event) => { onChange(event.target.value); }}
          >
            <option value="">{I18n.t('BEE793' /* Todos */)}</option>
            {StockMovementsHelpers.movementType().map((element, index) => (
              <option key={index} value={element.value}>
                {element.label}
              </option>
            ))}
          </select>
        ),
      }, {
        Header: I18n.t('BEE524' /* Operação */),
        accessor: 'operation',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE1378' /* Documento */),
        accessor: 'orderNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE4524' /* Número de Carga */),
        accessor: 'loadNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE402' /* Nota Fiscal */),
        accessor: 'invoiceNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE84' /* Razão Social */),
        accessor: 'socialName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE182' /* Depósito */),
        accessor: 'depositName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 120,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE225' /* Produto */),
        accessor: 'productCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE425' /* Batismo */),
        accessor: 'baptismLabel',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE277' /* Descrição */),
        accessor: 'name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 350,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE441' /* Quantidade */),
        accessor: 'quantity',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 110,
        Cell: (row) => FormatHelpers.formatNumber(row.value || 0, 4),
        filterable: false,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE384' /* Unidade */),
        accessor: 'unitMeasure',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 90,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE432' /* Endereço */),
        accessor: 'addressCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE428' /* Lote */),
        accessor: 'lotNumber',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE2398' /* Data de Validade */),
        accessor: 'expirationDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        Cell: (row) => (
          <div>
            <span>
              {' '}
              {row.value}
            </span>
          </div>
        ),
      }, {
        Header: I18n.t('BEE488' /* Data de Fabricação */),
        accessor: 'manufacturingDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: this.filterColumn,
        Cell: (row) => (
          <div>
            <span>
              {' '}
              {row.value}
            </span>
          </div>
        ),
      }, {
        Header: I18n.t('BEE1516' /* Agrupador */),
        accessor: 'serialGroup',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 250,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE2760' /* Etiqueta Seriada */),
        accessor: 'serialLabel',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 250,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE523' /* Data Movimento */),
        accessor: 'movementDate',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 170,
        filterMethod: (filter, row) => {
          const input = _.lowerCase(filter.value);
          const dateFirstOption = moment(row[filter.id]).format('DD MM YYYY HH:mm:ss');
          const dateSecondOption = moment(row[filter.id]).format('DDMMYYYY HH:mm:ss');
          if (_.includes(dateFirstOption, input) || _.includes(dateSecondOption, input)) {
            return true;
          }
        },
        Cell: (row) => (
          <span>
            {' '}
            {row.value ? moment(row.value).format('L LTS') : ''}
          </span>
        ),
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE522' /* Usuário Movimento */),
        accessor: 'movementUserName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 170,
        Filter: this.filterColumn,
      }, {
        Header: I18n.t('BEE135' /* Observação */),
        accessor: 'note',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 300,
        Filter: this.filterColumn,
      },
    ];
  }

  componentDidMount() {
    this.getPageLayout().then(() => this.updateColumns());
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.userLogged && this.props.userLogged) {
      this.getPageLayout().then(() => this.updateColumns());
    }
  }

  updateColumns = () => {
    this.setState({ tableColumns: this.getTableColumns() });
  };

  getTableColumns = () => {
    const { pageLayout = {} } = this.state;
    return this.allTableColumns.map((col) => ({
      ...col,
      show: this.showColumn(pageLayout, `show${col.accessor.charAt(0).toUpperCase()}${col.accessor.slice(1)}`),
    }));
  };

  getPageLayout = async () => {
    const { userLogged } = this.props;
    if (userLogged && userLogged.mainBranchData) {
      const layoutSelected = await this.props.getPageLayout({
        branchCode: userLogged.mainBranchData.code,
        page: this.props.location.pathname,
      });
      if (layoutSelected && layoutSelected.layout) {
        this.setState({
          pageLayout: { ...layoutSelected.layout },
          ...layoutSelected.layout,
        });
      }
    }
  };

  showColumn = (layout, fieldName) => {
    if (layout) {
      return layout[fieldName] !== false;
    }
    return true;
  };

  setValue = (attr, value) => {
    this.setState({ [attr]: value });
  };

  showPageLayoutModal = () => {
    this.setState({ showModalPageLayout: true });
  };

  closePageLayoutModal = () => {
    this.getPageLayout();
    this.setState({ showModalPageLayout: false });
  };

  resetLayout = () => {
    this.setState({
      showLoadNumber: true,
      showInvoiceNumber: true,
      showSocialName: true,
      showDepositName: true,
      showBaptismLabel: true,
      showName: true,
      showUnitMeasure: true,
      showAddressCode: true,
      showLotNumber: true,
      showExpirationDate: true,
      showManufacturingDate: true,
      showSerialGroup: true,
      showSerialLabel: true,
      showMovementUserName: true,
      showNote: true,
    });
  };

  updatePageLayoutArray = async () => {
    const {
      showLoadNumber,
      showInvoiceNumber, showSocialName, showDepositName, showBaptismLabel,
      showName, showUnitMeasure, showAddressCode, showLotNumber,
      showExpirationDate, showManufacturingDate, showSerialGroup, showSerialLabel, showMovementUserName, showNote,
    } = this.state;

    const layout = {
      showLoadNumber,
      showInvoiceNumber,
      showSocialName,
      showDepositName,
      showBaptismLabel,
      showName,
      showUnitMeasure,
      showAddressCode,
      showLotNumber,
      showExpirationDate,
      showManufacturingDate,
      showSerialGroup,
      showSerialLabel,
      showMovementUserName,
      showNote,
    };

    try {
      const { userLogged } = this.props;

      if (userLogged && userLogged.mainBranchData) {
        const { mainBranchData } = userLogged;

        const updLayout = this.props.updatePageLayout({
          branchCode: mainBranchData.code,
          page: this.props.location.pathname,
          layout,
        });

        if (updLayout) {
          addNotification(
            'success',
            I18n.t('BEE4440' /* Atualizar Layout da Página */),
            I18n.t('BEE4442' /* Atualização do Layout de Página efetuada com sucesso! */),
            'top-right',
          );

          this.setState({
            pageLayout: layout,
          });
          this.updateColumns();
        }
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE4440' /* Atualizar Layout da Página */),
            `${error.code} - ${error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE4440' /* Atualizar Layout da Página */),
            I18n.t('BEE4441' /* Erro ao atualizar o Layout de Página */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4440' /* Atualizar Layout da Página */),
          I18n.t('BEE4441' /* Erro ao atualizar o Layout de Página */),
          'top-right',
        );
      }
    }

    this.setState({
      showModalPageLayout: false,
    });
  };

  createPageLayoutModal = () => {
    const {
      showModalPageLayout, showLoadNumber,
      showInvoiceNumber, showSocialName, showDepositName, showBaptismLabel,
      showName, showUnitMeasure, showAddressCode, showLotNumber,
      showExpirationDate, showManufacturingDate, showSerialGroup, showSerialLabel, showMovementUserName, showNote,
    } = this.state;

    return (
      <Modal
        size="md"
        isOpen={showModalPageLayout}
        toggle={() => this.closePageLayoutModal()}
      >
        <ModalHeader toggle={() => this.closePageLayoutModal()}>
          <span className="text-center">
            {I18n.t('BEE4439' /* Gerenciar Colunas */).toLocaleUpperCase()}
          </span>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12 text-right">
            <div className="d-flex flex-column align-items-left m-5 p-5">
              <Form
                noPanel
                setValue={this.setValue}
                inputs={(formContext) => ([
                  formContext.createToggleBox(
                    showLoadNumber,
                    'showLoadNumber',
                    I18n.t('BEE4524' /* Número de Carga */),
                  ),
                  formContext.createToggleBox(
                    showInvoiceNumber,
                    'showInvoiceNumber',
                    I18n.t('BEE402' /* Nota Fiscal */),
                  ),
                  formContext.createToggleBox(
                    showSocialName,
                    'showSocialName',
                    I18n.t('BEE84' /* Razão Social */),
                  ),
                  formContext.createToggleBox(
                    showDepositName,
                    'showDepositName',
                    I18n.t('BEE182' /* Depósito */),
                  ),
                  formContext.createToggleBox(
                    showBaptismLabel,
                    'showBaptismLabel',
                    I18n.t('BEE425' /* Batismo */),
                  ),
                  formContext.createToggleBox(
                    showName,
                    'showName',
                    I18n.t('BEE277' /* Descrição */),
                  ),
                  formContext.createToggleBox(
                    showUnitMeasure,
                    'showUnitMeasure',
                    I18n.t('BEE384' /* Unidade */),
                  ),
                  formContext.createToggleBox(
                    showAddressCode,
                    'showAddressCode',
                    I18n.t('BEE432' /* Endereço */),
                  ),
                  formContext.createToggleBox(
                    showLotNumber,
                    'showLotNumber',
                    I18n.t('BEE428' /* Lote */),
                  ),
                  formContext.createToggleBox(
                    showExpirationDate,
                    'showExpirationDate',
                    I18n.t('BEE2398' /* Data de Validade */),
                  ),
                  formContext.createToggleBox(
                    showManufacturingDate,
                    'showManufacturingDate',
                    I18n.t('BEE488' /* Data de Fabricação */),
                  ),
                  formContext.createToggleBox(
                    showSerialGroup,
                    'showSerialGroup',
                    I18n.t('BEE1516' /* Agrupador */),
                  ),
                  formContext.createToggleBox(
                    showSerialLabel,
                    'showSerialLabel',
                    I18n.t('BEE2760' /* Etiqueta Seriada */),
                  ),
                  formContext.createToggleBox(
                    showMovementUserName,
                    'showMovementUserName',
                    I18n.t('BEE522' /* Usuário Movimento */),
                  ),
                  formContext.createToggleBox(
                    showNote,
                    'showNote',
                    I18n.t('BEE135' /* Observação */),
                  ),
                ])}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex justify-content-between w-100">
            <button
              type="button"
              className="btn btn-120 btn-primary p-5 m-5"
              onClick={this.resetLayout}
            >
              {I18n.t('BEE4443' /* Restaurar padrão */)}
            </button>
            <div>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-white p-5 m-5"
                onClick={this.closePageLayoutModal}
              >
                {I18n.t('BEE99' /* Cancelar */)}
              </OneClickButton>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-primary p-5 m-5"
                onClick={this.updatePageLayoutArray}
              >
                {I18n.t('BEE139' /* Atualizar */)}
              </OneClickButton>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  };

  filterColumn = ({ onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (event.target.value === '' && (event.keyCode === 8 || event.which === 8)) {
          onChange(event.target.value);
        }
      }}
    />
  );

  getStockMovements = async () => {
    const { startDate, endDate, totalDataLength } = this.state;
    const formattedStartDate = moment(startDate).format();
    const formattedEndDate = moment(endDate).format();
    const dateSignature = `${formattedStartDate}|${formattedEndDate}`;
    const sorted = [...this.sorted];

    const movementDateIndex = sorted.findIndex((element) => element.id === 'movementDate');
    const hasIdSort = sorted.some((element) => element.id === 'id');

    if (movementDateIndex >= 0 && !hasIdSort) {
      sorted.push({ id: 'id', desc: sorted[movementDateIndex].desc });
    }

    const tableParams = {
      page: this.page,
      pageSize: this.pageSize,
      sorted,
      filtered: this.filtered,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };

    if (this.lastDateSignature === dateSignature && totalDataLength > 0) {
      tableParams.totalDataLength = totalDataLength;
    }

    const data = await this.props.getStockMovements(tableParams);

    this.lastDateSignature = dateSignature;
    this.setState({ pages: data.pages, totalDataLength: data.totalDataLength });
  };

  handleDateApplyEvent = async (event) => {
    const startDate = event[0];
    const endDate = event[1];

    this.lastDateSignature = null;

    await this.setState({
      startDate,
      endDate,
      totalDataLength: 0,
    });

    this.getStockMovements();
  };

  reloadStockMovements = () => {
    this.lastDateSignature = null;
    this.setState({ totalDataLength: 0 }, () => {
      this.getStockMovements();
    });
  };

  render() {
    const { stockMovementsList = [] } = this.props;
    const { pages, totalDataLength } = this.state;

    return (
      <div>
        <div className="d-flex align-items-right">
          <ol className="breadcrumb float-xl-right">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE33' /* Consultas */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE32' /* Estoque */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE525' /* Movimentos Estoque */)}</li>
          </ol>
        </div>
        <Table
          customRangeMessage={I18n.t('BEE3342', { 0: (I18n.t('BEE3345' /* data do movimento de estoque */)) })}
          downloadCSV
          headerTitle={I18n.t('BEE525' /* Movimentos Estoque */)}
          wikiHelp={ROUTES.STOCK_MOVEMENT_HELP}
          panelHeaderProps={{
            onClickReload: this.reloadStockMovements,
          }}
          datePicker={{
            handleDateApplyEvent: this.handleDateApplyEvent,
          }}
          downButtonPosition
          actionButtons={(
            <div className="ml-auto">
              <button
                type="button"
                className="btn btn-primary p-5"
                onClick={() => this.showPageLayoutModal()}
              >
                {I18n.t('BEE4439' /* Gerenciar Colunas */)}
              </button>
            </div>
          )}
          filterable
          data={stockMovementsList}
          totalDataLength={totalDataLength}
          columns={this.state.tableColumns}
          expander
          defaultPageSize={10}
          defaultSorted={this.defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          manual
          pages={pages}
          onFetchData={(state) => {
            this.page = state.page;
            this.pageSize = state.pageSize;
            this.sorted = state.sorted;
            this.filtered = state.filtered;
            this.getStockMovements();
          }}
        />
        {this.createPageLayoutModal()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  stockMovementsList: state.stocks && state.stocks.movementsList,
  userLogged: state.app && state.app.userLogged,
});

const mapDispatchToProps = (dispatch) => ({
  getStockMovements: (tableParams) => dispatch(getStockMovements(tableParams)),
  getPageLayout: (pageLayout) => dispatch(getPageLayout(pageLayout)),
  updatePageLayout: (pageLayout) => dispatch(updatePageLayout(pageLayout)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StockMovementList));
